import { twMerge } from 'tailwind-merge';
import type { SelectedTeeth } from '@witmetrics/utils';
import {
  LOWER_LEFT_TEETH,
  LOWER_RIGHT_TEETH,
  UPPER_LEFT_TEETH,
  UPPER_RIGHT_TEETH,
} from '@witmetrics/utils/constants';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { classes, styles } from './utils';

export type ToothSelectorProps = {
  className?: string;
  value: SelectedTeeth;
  onChange: (value: SelectedTeeth) => void;
};

export default function ToothSelector({
  className,
  value,
  onChange,
}: ToothSelectorProps) {
  return (
    <>
      <label className={classes.label}>Unmovable Teeth</label>
      <div className={twMerge(classes.wrapper, className)}>
        <ToggleBlock<SelectedTeeth['upperRight']>
          exclusive={false}
          className={classes.toggleBlock}
          value={value.upperRight}
          onChange={(upperRight) => onChange({ ...value, upperRight })}>
          {[...UPPER_RIGHT_TEETH].reverse().map((tooth) => (
            <ToggleOption
              key={tooth}
              sx={styles.option}
              className={classes.option}
              value={tooth}>
              {tooth}
            </ToggleOption>
          ))}
        </ToggleBlock>
        <ToggleBlock<SelectedTeeth['upperLeft']>
          exclusive={false}
          className={classes.toggleBlock}
          value={value.upperLeft}
          onChange={(upperLeft) => onChange({ ...value, upperLeft })}>
          {UPPER_LEFT_TEETH.map((tooth) => (
            <ToggleOption
              key={tooth}
              sx={styles.option}
              className={classes.option}
              value={tooth}>
              {tooth}
            </ToggleOption>
          ))}
        </ToggleBlock>
        <ToggleBlock<SelectedTeeth['lowerRight']>
          exclusive={false}
          className={classes.toggleBlock}
          value={value.lowerRight}
          onChange={(lowerRight) => onChange({ ...value, lowerRight })}>
          {[...LOWER_RIGHT_TEETH].reverse().map((tooth) => (
            <ToggleOption
              key={tooth}
              sx={styles.option}
              className={classes.option}
              value={tooth}>
              {tooth}
            </ToggleOption>
          ))}
        </ToggleBlock>
        <ToggleBlock<SelectedTeeth['lowerLeft']>
          exclusive={false}
          className={classes.toggleBlock}
          value={value.lowerLeft}
          onChange={(lowerLeft) => onChange({ ...value, lowerLeft })}>
          {LOWER_LEFT_TEETH.map((tooth) => (
            <ToggleOption
              key={tooth}
              sx={styles.option}
              className={classes.option}
              value={tooth}>
              {tooth}
            </ToggleOption>
          ))}
        </ToggleBlock>
      </div>
    </>
  );
}
